<ng-container *ngIf="enableToRegister">
    <div class="options-container">
        <cm-self-enrollment-registration [organizationRoles]="organizationRoles"></cm-self-enrollment-registration>
    </div>
    <footer class="entry-page-form-footer">
        Already have an account?<a class="cm-link" href="javascript:void(0);" (click)="redirectToLogin()">Sign in</a>
    </footer>
</ng-container>

<div class="self-enrollment-unavailable" *ngIf="!enableToRegister">
    <h2 class="hero-title">Link is unavailable</h2>
    <p class="problem-description">The self-enrollment link you are looking for is already unavailable.</p>
</div>
